import Accordion from '@components/V4/Accordion';
import { ParentFeedback } from '@shared/common';
import SessionModalEmptyState from '../../../DetailsModalEmptyState';
import FeedbackEntry from './FeedbackEntry';

interface ParentFeedbackAccordionProps {
  parentFeedback?: ParentFeedback;
  defaultIsAccordionOpen: boolean;
}

const ParentFeedbackAccordion = (props: ParentFeedbackAccordionProps) => {
  const { parentFeedback, defaultIsAccordionOpen } = props;
  return (
    <Accordion
      defaultIsOpen={defaultIsAccordionOpen}
      titleWrapperClassName="bg-surfaceHover p-2"
      title={<p className="font-raleway font-medium text-xs text-white">Parent Feedback</p>}
      className="flex flex-col gap-4 my-2 px-2 max-h-[80px] laptop:max-h-[140px]"
    >
      {!parentFeedback?.rating ? (
        <SessionModalEmptyState />
      ) : (
        <FeedbackEntry
          title="Message:"
          score={`${parentFeedback?.rating}/5`}
          starRating={parentFeedback?.rating}
          description={parentFeedback?.message || 'n/a'}
        />
      )}
    </Accordion>
  );
};

export default ParentFeedbackAccordion;
